<template>
  <component
    :is="tagName"
    class="three-d-button"
    :href="href"
    :to="to"
    :type="buttonType"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <FaIcon
      v-if="icon && iconPosition === 'left'"
      :icon="icon"
      class="three-d-button-icon three-d-button-icon-left"
    />
    <slot />
    <FaIcon
      v-if="icon && iconPosition === 'right'"
      :icon="icon"
      class="three-d-button-icon three-d-button-icon-right"
    />
  </component>
</template>
<script>
import FaIcon from '@/components/ui/FaIcon'

export default {
  name: 'ThreeDButton',
  components: { FaIcon },
  props: {
    href: {
      type: String,
      required: false,
    },
    to: {
      type: [String, Object],
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    iconPosition: {
      type: String,
      default: 'left',
    },
    /**
     * Any valid button type. Only applies for fancy buttons rendered as a button element.
     */
    type: {
      type: String,
      default: 'button',
    },
  },
  computed: {
    buttonType() {
      return this.isLink ? null : this.type
    },
    isLink() {
      return !!(this.href || this.to)
    },
    tagName() {
      if (this.to) {
        return 'router-link'
      }

      if (this.href) {
        return 'a'
      }

      return 'button'
    },
  },
}
</script>

<style lang="scss" scoped>
.three-d-button {
  --button-color: #{$mainColor};
  --button-shadow-color: #{mix($mainColor, $black)};
  --button-shadow-size: 0.33em;
  --button-overlay-opacity: 0;
  --button-border-radius: 0.6em;

  position: relative;
  display: inline-block;
  padding: 0.1em 1.5em 0;
  vertical-align: middle;
  line-height: 2.4em;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-shadow: 0 var(--button-shadow-size) 0 0 var(--button-shadow-color);
  background: var(--button-color);
  color: $white !important;
  font-family: Poppins, sans-serif;
  font-weight: bold;
  font-size: 1em;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: var(--button-border-radius);
  border: none !important;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  transform: translateY(calc(-1 * var(--button-shadow-size)));

  &:after {
    position: absolute;
    display: block;
    content: '';
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: $white;
    opacity: var(--button-overlay-opacity);
    transition: opacity 0.2s ease-in-out;
  }

  &:disabled {
    --button-shadow-size: 0em; // em is important here, since MS Edge 44.17763.1.0 crashes hard if we omit it
    --button-overlay-opacity: 0.5;
  }

  &:not(:disabled) {
    @media (hover: hover) {
      &:focus,
      &:hover {
        --button-shadow-size: 0.25em;
        --button-overlay-opacity: 0.05;
      }
    }

    &:active {
      --button-shadow-size: 0;
      transition: all 0.1s ease-out;
    }
  }
}
.three-d-button-icon-left {
  margin-right: 0.3em;
}
.three-d-button-icon-right {
  margin-left: 0.3em;
}
</style>
